"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _HttpRequest = require("../../../../utils/HttpRequest");

var _BuildConstants = require("../../../../utils/BuildConstants");

var _config = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/config.js"));

var _RegisterInstance = _interopRequireDefault(require("../../RegisterInstance"));

var _TimeoutHelper = require("../../../../helpers/TimeoutHelper");

/**
 * Created by falknisius on 31.05.17.
 */
var GetFullUsage = /*#__PURE__*/function () {
  function GetFullUsage() {
    (0, _classCallCheck2["default"])(this, GetFullUsage);
  }

  (0, _createClass2["default"])(GetFullUsage, null, [{
    key: "askForUsageStats",
    value: function () {
      var _askForUsageStats = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var url, data, result, token;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_config["default"]) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return (0, _TimeoutHelper.timeout)(100);

              case 3:
                return _context.abrupt("return", GetFullUsage.askForUsageStats());

              case 4:
                if (_config["default"].usagesRetrieveUrl) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", _promise["default"].reject(new Error('no usages retrieve url found')));

              case 6:
                url = _BuildConstants.LEDGER_HOST + '/' + _config["default"].usagesRetrieveUrl;
                data = {};
                _context.prev = 8;

                if (!_config["default"].backendUseBearerAuth) {
                  _context.next = 18;
                  break;
                }

                _context.next = 12;
                return _RegisterInstance["default"].getAccessToken('logAggregate:read');

              case 12:
                token = _context.sent;
                _context.next = 15;
                return (0, _HttpRequest.httpGet)(url, data, null, null, 2, 'Bearer ' + token);

              case 15:
                result = _context.sent;
                _context.next = 21;
                break;

              case 18:
                _context.next = 20;
                return (0, _HttpRequest.httpGet)(url, data, null, null, 2, null);

              case 20:
                result = _context.sent;

              case 21:
                if (!(result.status === 200)) {
                  _context.next = 25;
                  break;
                }

                return _context.abrupt("return", _promise["default"].resolve(result));

              case 25:
                return _context.abrupt("return", _promise["default"].reject(new Error('ERROR_HTTP_COMMUNICATION')));

              case 26:
                _context.next = 32;
                break;

              case 28:
                _context.prev = 28;
                _context.t0 = _context["catch"](8);
                console.error(_context.t0);
                return _context.abrupt("return", _promise["default"].reject(_context.t0));

              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[8, 28]]);
      }));

      function askForUsageStats() {
        return _askForUsageStats.apply(this, arguments);
      }

      return askForUsageStats;
    }()
  }]);
  return GetFullUsage;
}();

var _default = GetFullUsage;
exports["default"] = _default;